import { Card, CardBody, CardTitle } from "reactstrap";
import { IPosition } from '../../types/position';
import Tabs, { Tab } from '../common/tabs/tabs';
import PositionContactInfo from './contact-info/contact-info';
import PositionDetails from './position-detail/position-details';
import OmsToolTip from "../common/oms-tooltip/oms-tooltip";
import { useState } from "react";

type PositionProps = {
  //selectedTreeItem:ICategory | IOrg | undefined;
  position: IPosition;
  updateSelectedPosition?: (updatedPosition: IPosition) => void;
  onExpirePosition?: () => void;

}

const PositionDetailsInfo = (props: PositionProps) => {
  const { position, updateSelectedPosition, onExpirePosition } = props
  const [updatedPosition,setUpdatedPosition] = useState<IPosition>();

  //console.log("position:",position)

  const updatePosition = (position:IPosition) => {
    setUpdatedPosition(position);
    updateSelectedPosition&&updateSelectedPosition(position);
  }

  const tabs: Tab[] = [
    {
      title: 'Position Details',
      content: <PositionDetails position={position} updateSelectedPosition={updatePosition} onExpirePosition={onExpirePosition} ></PositionDetails>
    },
    {
      title: 'Contact Information',
      content: <PositionContactInfo position={position}></PositionContactInfo>
    }
  ]

  return (
    <Card aria-label="Position Information">
      <CardBody>
        <CardTitle>        
          Position: {updatedPosition?updatedPosition.fullPositionName: position?.fullPositionName}
        </CardTitle>

        <Tabs tabs={tabs} />
      </CardBody>
    </Card>
  )
}

export default PositionDetailsInfo
